export default function (cell, formatterParams) {
  let value = (cell.getValue() || []);

  if (!value.length) {
    return '<br/>';
  }

  const wrap = document.createElement('div');

  wrap.innerHTML = value.map(formatOne).join('');

  return wrap;
}

function formatOne({ name, date, route, complete, content }) {

  const el = document.createElement("div");

  const label = document.createElement('span');
  label.innerHTML = `${name} ${date ? `(${date})` : ''}`.trim();

  const icon = document.createElement('span');
  icon.classList.add('fa', complete ? 'fa-check-circle' : 'fa-times-circle');


  if (!route) {
    el.appendChild(icon);
    el.appendChild(label)

    return el;
  }

  const link = document.createElement("a");
  link.appendChild(icon);
  link.appendChild(label);
  link.href = route;
  link.title = content;

  el.appendChild(link);
  return el.outerHTML;
}